// Aggregator for all courses in the app.
// Adds metadata (slug, accent, hub copy) and exposes helpers used by the
// hub and the lesson deep-link resolver.

import { COURSE as HORMONE_COURSE } from "@/data/course";
import { MICROBIOME_COURSE } from "@/data/microbiomeCourse";

// Annotate hormone course with a slug for routing (the file itself doesn't
// have one — it predates the multi-course architecture).
const HORMONE = { ...HORMONE_COURSE, slug: "hormone" };
const MICROBIOME = { ...MICROBIOME_COURSE, slug: "microbiome" };

export const COURSES = [
  {
    slug: "hormone",
    course: HORMONE,
    accent: "--mod-1",
    tagline: "Women's health · estrogen & the gut",
    hubBlurb:
      "How your microbiome controls estrogen. 4 modules, 7 lessons on the estrobolome, β-glucuronidase and reclaiming hormonal balance.",
  },
  {
    slug: "microbiome",
    course: MICROBIOME,
    accent: "--mod-6",
    tagline: "Microbe to medicine · the human ecosystem",
    hubBlurb:
      "Built from Murray's Medical Microbiology and integrative research. 8 modules. The flagship Gut-Hormones-Mood module is live now; more modules unlock as we publish them.",
  },
];

export function getCourseBySlug(slug) {
  return COURSES.find((c) => c.slug === slug);
}

// Build a lesson index across all courses for deep-linking.
// Each entry knows which course owns it.
export const ALL_LESSONS = COURSES.flatMap((c) =>
  c.course.modules.flatMap((m, mi) =>
    m.lessons.map((l, li) => ({
      courseSlug: c.slug,
      lessonId: l.id,
      moduleIndex: mi,
      lessonIndex: li,
      title: l.title,
      moduleTitle: m.title,
    }))
  )
);

export function findLessonLocation(lessonId) {
  return ALL_LESSONS.find((l) => l.lessonId === lessonId) || null;
}

// Count completed lessons for a course given a completed-map (id → bool).
export function courseProgress(course, completed) {
  const allIds = course.modules.flatMap((m) => m.lessons.map((l) => l.id));
  const total = allIds.length;
  const done = allIds.filter((id) => completed[id]).length;
  return {
    total,
    done,
    percent: total === 0 ? 0 : Math.round((done / total) * 100),
  };
}
